export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/favicon.891b7d3c-81db23.jpg";